import { render, staticRenderFns } from "./management.vue?vue&type=template&id=ffa759e2"
import script from "./management.vue?vue&type=script&lang=ts"
export * from "./management.vue?vue&type=script&lang=ts"
import style0 from "./management.vue?vue&type=style&index=0&id=ffa759e2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports